import * as React from 'react';

// tslint:disable:max-line-length
export const MuseumIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M13.9 3.8c-3.6-1.7-6.6 1.8-8 0-.5-.7.7-2 0-2.9C5.4.3 4.2.4 3.5.9 1.4 2.4 0 4.8 0 7.5c0 4.4 3.6 8 8 8 3.7 0 6.8-2.5 7.7-5.9.4-1.1.8-4.5-1.8-5.8zM3 8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm2 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm4 2c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm3-4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    />
  </svg>
);
